import MkuRow from '../grid/row';

MkuRow.install = function (Vue) {
  Vue.component(MkuRow.name, MkuRow);
};

export default MkuRow;
